export default {
  APP_VERSION: "8.9596",
  APP_NAME: "LABSQUIRE",
  S3_BUCKET_URL: process.env.VUE_APP_S3_BUCKET_URL,
  API_URL: process.env.VUE_APP_LOCAL_API_URL,
}
